import { lazy } from 'react';
export const LazySubscriptionSuccess = lazy(() => import('@/pages/onboarding/SubscriptionSuccess'));
